export const add = {
  gender: {
    required: {
      rule: true, message: 'Vous devez choisir un titre'
    }
  },
  leader_lastname: {
    required: {
      rule: true, message: 'Vous devez indiquer un nom'
    }
  },
  leader_firstname: {
    required: {
      rule: true, message: 'Vous devez indiquer un prénom'
    }
  },
  date_birth: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  /*
  address: {
    required: {
      rule: true, message: 'Vous devez indiquer une adresse'
    }
  },
  zip: {
    required: {
      rule: true, message: 'Vous devez indiquer un code postal'
    },
    minLength: {
      rule: 5, initial: 'off'
    },
    maxLength: {
      rule: 5, initial: 'off'
    }
  },
  city: {
    required: {
      rule: true
    }
  },
  email: {
    required: {
      rule: true, message: 'Vous devez indiquer une adresse email'
    },
    validateEmail: {
      rule: true, message: "L'adresse email fournie n'est pas valide", initial: 'off'
    }
  },
  */
  phone: {
    validatePhone: {
      rule: true, message: 'Le numéro de téléphone renseigné n\'est pas valide'
    }
  },
  mobile: {
    validatePhone: {
      rule: true, message: 'Le numéro de mobile renseigné n\'est pas valide'
    }
  },
  ss_num: {
    validateSecu: {
      rule: true, message: 'Le numéro de sécu renseigné n\'est pas valide'
    }
  }
}

export const edit = {
  gender: {
    required: {
      rule: true, message: 'Vous devez choisir un titre'
    }
  },
  leader_lastname: {
    required: {
      rule: true, message: 'Vous devez indiquer un nom'
    }
  },
  leader_firstname: {
    required: {
      rule: true, message: 'Vous devez indiquer un prénom'
    }
  },
  date_birth: {
    validateDate: {
      rule: true, message: 'La date n\'a pas un format valide'
    }
  },
  /*
  address: {
    required: {
      rule: true, message: 'Vous devez indiquer une adresse'
    }
  },
  zip: {
    required: {
      rule: true, message: 'Vous devez indiquer un code postal'
    }
  },
  city: {
    required: {
      rule: true
    }
  },
  email: {
    required: {
      rule: true, message: 'Vous devez indiquer une adresse email'
    },
    validateEmail: {
      rule: true, message: "L'adresse email fournie n'est pas valide", initial: 'off'
    }
  },
  */
  phone: {
    validatePhone: {
      rule: true, message: 'Le numéro de téléphone renseigné n\'est pas valide'
    }
  },
  mobile: {
    validatePhone: {
      rule: true, message: 'Le numéro de mobile renseigné n\'est pas valide'
    }
  },
  ss_num: {
    validateSecu: {
      rule: true, message: 'Le numéro de sécu renseigné n\'est pas valide'
    }
  }
}



// WEBPACK FOOTER //
// ./src/validations/contact.js